import React from "react";
import PropTypes from "prop-types";
import "./index.less";
import mock from "./mock.json";
import CountUp from 'react-countup';

/**
 * 视图组件
 */
const Statistic = props => {
  const {template, datas} = props;
  return (
    <div className="weax-iconblock-statistic">
      {datas.map((data, index) => renderTemp(index, template, data))}
    </div>
  );
};

/**
 * 函数-判断使用哪个模板进行渲染
 * @param {String} template 模板标识
 * @param {Object} data 卡片信息
 */
const renderTemp = (key, template, data) => {
  switch (template) {
    case "temp1":
      return <StatisticTemp1 key={key} {...data} />;
    case "temp2":
      return <StatisticTemp1 key={key} {...data} />;
    case "temp3":
      return <StatisticTemp1 key={key} {...data} />;
    case "temp4":
      return <StatisticTemp1 key={key} {...data} />;
    case "temp5":
      return <StatisticTemp1 key={key} {...data} />;
    default:
      return <StatisticTemp1 key={key} {...data} />;
  }
};

/**
 * 函数-数值渐进曲线
 * @param {*} t 
 * @param {*} b 
 * @param {*} c 
 * @param {*} d 
 */
const easingFn = (t, b, c, d) => {
  var ts = (t /= d) * t;
  var tc = ts * t;
  return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
}

/**
 * 模板-样式1
 * @param {Array} datas
 */
const StatisticTemp1 = datas => {
  return (
    <div className="weax-iconblock-statistic-group">
      <div className="weax-iconblock-statistic-item">
        <h3 className="weax-iconblock-statistic-title">{datas.title}</h3>
        <h2 className="weax-iconblock-statistic-value">
          <CountUp end={datas.value} separator="," easingFn={easingFn}/>
        </h2>
        <div className="weax-iconblock-statistic-progress">
          <div className="weax-iconblock-statistic-progress-inner" style={{ width: `${Math.abs(datas.rate)}%`, opacity: 1, }} />
          {/* <div className="weax-iconblock-statistic-progress-inner move" style={{ width: `${Math.abs(datas.rate)}%`, opacity: 1, }} /> */}
        </div>
        <p className="weax-iconblock-statistic-rate">
          {datas.rate > 0 ? (
            <i className="weax-iconblock-statistic-rate-increase">
              +{<CountUp end={Math.round(Math.abs(datas.rate))} separator="," easingFn={easingFn} duration={5} />}
            </i>
          ) : (
            <i className="weax-iconblock-statistic-rate-decrease">
              -{<CountUp end={Math.round(Math.abs(datas.rate))} separator="," easingFn={easingFn} duration={5} />}
            </i>
          )}
          %
        </p>
      </div>
    </div>
  );
};

/**
 * 模板-样式2
 * @param {Object} datas
 */
const StatisticTemp2 = datas => (
  <div className="weax-iconblock-statistic-container">
    <h2>Awesome {datas.title} Temp2</h2>
  </div>
);

Statistic.defaultProps = {
  template: "temp1",
  datas: mock
};

Statistic.propTypes = {
  template: PropTypes.oneOf(["temp1", "temp2"]),
  datas: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.number,
    rate: PropTypes.number
  }))
};

export default Statistic;
